import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";

Html.registerWidget('widget/activity-filter',{initDom})

function onchange(evt: Event){
  const target = evt.target as HTMLSelectElement;
  amplify.publish("activityFilterSelected",{filter:target.value});
}

function initDom(obj: HTMLElement){
  obj.addEventListener('change',onchange);
}